import styled from 'styled-components';
import {AnalysisItem, BasicAnalysisResult} from '@/map/@types';
import {usePresumePopulationPointBy} from '@/map/api';
import {getSidoName} from '@/map/utils';
import {Flexbox, FlexFullGrow, PaddingBox} from '@/styled-components';
import {palette} from '@/styles';
import {withComma} from '@/utils';
import {BarChart} from '../BarChart';
import {SectionLabel, SectionValue} from '../StyledComponents';
import {CompareAverage} from './CompareAvg';

interface IProps {
  item: AnalysisItem;
  data?: BasicAnalysisResult;
}

const AGE_GROUP = [
  '10대 미만',
  '10대',
  '20대',
  '30대',
  '40대',
  '50대',
  '60대 이상',
];

export const ResidentPopulation = ({data, item}: IProps) => {
  if (!data || !data?.population) {
    return (
      <Root>
        <Flexbox>
          <SectionLabel>거주 인구(추정)</SectionLabel>
          <FlexFullGrow />
          <SectionValue color={palette.gray300}>정보 없음</SectionValue>
        </Flexbox>
      </Root>
    );
  }

  const ctprvn = getSidoName(data?.average?.sido);
  const avg = data?.average?.population;

  return (
    <Root>
      <Flexbox>
        <SectionLabel>거주 인구(추정)</SectionLabel>
        <FlexFullGrow />
        <SectionValue>{withComma(data?.population)} 명</SectionValue>
      </Flexbox>
      {!!avg && (
        <PaddingBox top={8}>
          <CompareAverage
            total={data?.population}
            average={avg}
            ctprvn={ctprvn}
          />
        </PaddingBox>
      )}
      <ChartData item={item} />
    </Root>
  );
};

const ChartData = ({item}: {item: AnalysisItem}) => {
  const {data, isPending, error} = usePresumePopulationPointBy(item);

  if (isPending || !!error || !data?.groupAge) {
    return null;
  }

  return <BarChart labels={AGE_GROUP} data={data.groupAge} />;
};

const Root = styled.div``;
